import React from 'react';
import { Card, CardContent } from './ui/card';
import { whySupportReasons } from '../data/mockData';
import { CheckCircle2 } from 'lucide-react';

const WhySupportSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Why Support Us
          </h2>
          <div className="w-24 h-1 bg-orange-600 mx-auto"></div>
        </div>

        <div className="mb-12 flex justify-center">
          <img
            src="https://prayatn.org/wp-content/uploads/2021/06/Prayatnwhytosupport.jpg"
            alt="Why support Prayatne"
            className="max-w-4xl w-full rounded-lg shadow-lg"
          />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whySupportReasons.map((reason) => (
            <Card
              key={reason.id}
              className="border-none shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <CardContent className="p-6">
                <div className="flex items-start space-x-3 mb-3">
                  <CheckCircle2 className="text-orange-600 flex-shrink-0 mt-1" size={24} />
                  <h3 className="text-xl font-bold text-gray-800">{reason.title}</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">{reason.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhySupportSection;